import React, { memo } from 'react'
import { PhoneInput } from 'transfix-ui/components/PhoneInput'
import { TextInput } from 'components/atoms'
import { Autocomplete } from 'components/forms'
import { IAutocomplete } from './CarrierInfo'

interface BookingInfoProps {
  children: React.ReactNode
}

const BookingInfo: React.FC<BookingInfoProps> = ({ children }) => (
  <section className='mt6'>
    <div className='b mb4'>Booking Contact Information</div>
    {children}
  </section>
)

export default BookingInfo

interface DispatcherSelectProps {
  changeDispatcherHandler: (selected: IAutocomplete) => void
  dispatcherId?: string
  carrierId?: string
}

export const DispatcherSelect = memo<DispatcherSelectProps>(
  ({ carrierId, changeDispatcherHandler, dispatcherId }) => (
    <Autocomplete
      onChange={changeDispatcherHandler}
      type='dispatcher'
      label='Dispatcher'
      dataTest='dispatcher-search'
      id='select-dispatcher-input'
      value={dispatcherId}
      companyId={carrierId}
      disabled={!carrierId}
    />
  )
)

interface PhoneEntryProps {
  changePhoneHandler: (event: React.ChangeEvent<HTMLInputElement>) => void
  changePhoneExtHandler: (event: React.ChangeEvent<HTMLInputElement>) => void
  contactPhone?: string
  contactPhoneExt?: string
  contactPhoneError?: string
}

export const PhoneEntry = memo<PhoneEntryProps>(
  ({
    changePhoneExtHandler,
    changePhoneHandler,
    contactPhone,
    contactPhoneError,
    contactPhoneExt,
  }) => (
    <fieldset>
      <div className='flex mt4'>
        <div className='dialog-medium'>
          <PhoneInput
            onChange={changePhoneHandler}
            dataTest='contact-phone'
            label='Phone'
            name='carrierContactPhone'
            value={contactPhone}
            invalid={Boolean(contactPhoneError)}
            validationMessage={contactPhoneError}
            clearable={false}
            required
          />
        </div>
        <div className='ml4 dialog-medium'>
          <TextInput
            onChange={changePhoneExtHandler}
            dataTest='contact-phone-ext'
            label='Ext'
            type='number'
            name='carrierContactPhoneExt'
            clearable={false}
            value={contactPhoneExt}
          />
        </div>
      </div>
    </fieldset>
  )
)
